import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_goals'

export default function DreamGoalsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What do you hope to achieve with dream journaling?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamGoals.heading')}
      buttons={[
        {
          text: `🧠 ${t('pages.onboarding.dreamGoals.options.selfUnderstanding')}`,
          value: 'Deeper self-understanding',
          subtext: t('pages.onboarding.dreamGoals.subtexts.selfUnderstanding'),
        },
        {
          text: `😌 ${t('pages.onboarding.dreamGoals.options.anxiety')}`,
          value: 'Reduce anxiety and stress',
          subtext: t('pages.onboarding.dreamGoals.subtexts.anxiety'),
        },
        {
          text: `🔮 ${t('pages.onboarding.dreamGoals.options.lucid')}`,
          value: 'Learn lucid dreaming',
          subtext: t('pages.onboarding.dreamGoals.subtexts.lucid'),
        },
        {
          text: `💡 ${t('pages.onboarding.dreamGoals.options.creativity')}`,
          value: 'Boost creativity',
          subtext: t('pages.onboarding.dreamGoals.subtexts.creativity'),
        },
        {
          text: `🌟 ${t('pages.onboarding.dreamGoals.options.spiritual')}`,
          value: 'Spiritual growth',
          subtext: t('pages.onboarding.dreamGoals.subtexts.spiritual'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
